import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import React, {useEffect, useState, useMemo} from "react"
import {
    Card,
    CardBody,
    Col,
    Container,
    Label,
    Row,
    Button,
    Input,
    CardTitle,
    Spinner,
    ModalHeader,
    ModalBody,
    Modal, Form,
} from "reactstrap"
import Select from "react-select"
import API from "../../apis"
import {withRouter} from "react-router-dom"
import PropTypes from "prop-types"
import countryList from "react-select-country-list"
import {ToastContainer, toast, Slide} from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const Profile = props => {
    var userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))
    var anneeScolaire = JSON.parse(localStorage.getItem("anneeScolaire"))
    var annee = anneeScolaire.Annee.annee
    var etudiant_id = userAuthEtudiant.user.id_etudiant
    var annee_id = userAuthEtudiant.user.annee_id
    const [loading, setLoading] = useState(true)
    const [id, setId] = useState("")
    const [sexe, setSexe] = useState(1);
    const [date, setDate] = useState("")
    const options = useMemo(() => countryList().getData(), [])
    const [etatCivil, setEtatCivil] = useState(1)
    const [gouvernorat, setGouvernorat] = useState([])
    const [selectGouvernorat, setSelectGouvernorat] = useState("");
    const [email, setEmail] = useState("")
    const [anneeBac, setAnneeBac] = useState(null)
    const [section, setSection] = useState([])
    const [selectSection, setSelectSection] = useState("");
    const [mention, setMention] = useState([])
    const [selectMention, setSelectMention] = useState("");
    const [session, setSession] = useState([])
    const [selectSession, setSelectSession] = useState("");
    const [cycle, setCycle] = useState([])
    const [selectCycle, setSelectCycle] = useState("")
    const [niveau, setNiveau] = useState([])
    const [selectNiveau, setSelectNiveau] = useState("")
    const [specialite, setSpecialite] = useState([])
    const [selectSpecialite, setSelectSpecialite] = useState("")
    const [groupe, setGroupe] = useState([])
    const [selectGroupe, setSelectGroupe] = useState("")
    const [file, setFile] = useState(null)
    const [cin, setCin] = useState("");
    const [numero_inscription, setNumero_inscription] = useState("");
    const [typeInscription, setTypeInscription] = useState([]);
    const [selectTypeInscription, setSelectTypeInscription] = useState("");
    const [derogataire, setDerogataire] = useState(2);
    const [prenom, setPrenom] = useState("")
    const [nom, setNom] = useState("")
    const [rue, setRue] = useState("")
    const [codePostal, setCodePostal] = useState("")
    const [lieuNaissance, setLieuNaissance] = useState("")
    const [selectNationality, setSelectNationality] = useState("")
    const [tel, setTel] = useState("")
    const [password, setPassword] = useState("")
    const [verifPassword, setVerifPassword] = useState("")
    const [errPass, setErrPass] = useState(1)
    const [prenomAr, setPrenomAr] = useState("")
    const [nomAr, setNomAr] = useState("")
    useEffect(async () => {
        API.get("type/inscription/select").then(restype => {
            setTypeInscription(restype.data.TypeInscription)
        })
        API.get("cycle/select").then(resC => {
            setCycle(resC.data.Cycle)
        })
        API.get("gouvernorat/select").then(res => {
            setGouvernorat(res.data.Gouvernorat)
        })
        API.get("mention/select").then(res => {
            setMention(res.data.Mention)
        })
        API.get("section/select").then(res => {
            setSection(res.data.Section)
        })
        API.get("session/select").then(res => {
            setSession(res.data.Session)
        })
        const res = await API.post("etudiant/get_by_id", {
            id: etudiant_id, annee_id
        }).then(res => {

            setId(res.data.etudiant.id)
            setNom(res.data.etudiant.nom)
            setNomAr(res.data.etudiant.nom_ar)
            setPrenom(res.data.etudiant.prenom)
            setPrenomAr(res.data.etudiant.prenom_ar)
            setCin(res.data.etudiant.cin)
            setNumero_inscription(res.data.etudiant.numero_inscription)
            setSexe(res.data.etudiant.sexe_id)
            setDate(new Date(res.data.etudiant.dateNaissance))
            setSelectNationality(res.data.etudiant.nationalite)
            setLieuNaissance(res.data.etudiant.lieuNaissance)
            setTel(res.data.etudiant.telephone)
            setEmail(res.data.etudiant.email)
            setRue(res.data.etudiant.rue)
            setCodePostal(res.data.etudiant.codePostal)
            setSelectGouvernorat(res.data.etudiant.gouvernorat)
            setAnneeBac(res.data.etudiant.anneBac)
            setSelectSection(res.data.etudiant.section)
            setSelectMention(res.data.etudiant.mention)
            setSelectSession(res.data.etudiant.session)
            setSelectCycle(res.data.etudiant.cycle)
            setSelectNiveau(res.data.etudiant.niveau)
            setSelectSpecialite(res.data.etudiant.specialite)
            setSelectGroupe(res.data.etudiant.group_td)
            setDerogataire(res.data.etudiant.derogataire)
            setSelectTypeInscription(res.data.etudiant.type_inscription)
            setLoading(true)
        })
    }, [])

    const getNiveau = async event => {
        var cycle_id = event.value
        setSelectCycle(event)
        setSelectNiveau("")
        setSelectSpecialite("")
        setSelectGroupe("")
        if (cycle_id == 1) {
            const res = await API.get("niveau/select").then(res => {
                setNiveau(res.data.Niveau)
            })
        } else {
            const res = await API.get("niveau/select_mastere").then(res => {
                setNiveau(res.data.Niveau)
            })
        }
    }

    const getSpec = async event => {
        var niveau_id = event.value
        setSelectSpecialite("")
        setSelectGroupe("")
        setSelectNiveau(event)
        const res = await API.post("specialite/get_by_niveau", {
            niveau_id: niveau_id,
            cycle_id: selectCycle.value,
        }).then(res => {
            setSpecialite(res.data.specialite)
        })
    }

    const getGroupe = async event => {
        var specialite_id = event.value
        setSelectSpecialite(event)
        setSelectGroupe("")
        const res = await API.post("group/getbysp", {
            specialite_id: specialite_id,
            cycle_id: selectCycle.value,
            niveau_id: selectNiveau.value,
            annee_id: annee_id
        }).then(res => {
            setGroupe(res.data.groups)
        })
    }

    const addFile = e => {
        var file = e.target.files[0]
        setFile(file)
    }

    const editEtudiant = async () => {
        if (date != "") {
            let dateComm = date
            let month = "" + (dateComm.getMonth() + 1)
            let day = "" + dateComm.getDate()
            let year = dateComm.getFullYear()
            if (month.length < 2) month = "0" + month
            if (day.length < 2) day = "0" + day
            var convertDate = [year, month, day].join("-")
        } else {
            var convertDate = ""
        }
        var pathFile = ""
        if (file !== "" && file != null) {
            pathFile = file.name
        }
        if (password === "") {
            var pass = 0
        } else {
            var pass = password
        }
        if (nom === "") {
            toast.error("⛔ Nom est obligatoire !! ", {
                containerId: "A",
            })
        } else if (nomAr === "") {
            toast.error("⛔ Nom  arabe obligatoire !!", {
                containerId: "A",
            })
        } else if (prenom === "") {
            toast.error("⛔ Prénom obligatoire !!", {
                containerId: "A",
            })
        } else if (prenomAr === "") {
            toast.error("⛔ Prénom arabe obligatoire !!", {
                containerId: "A",
            })
        } else if (cin === "") {
            toast.error("⛔ CIN obligatoire !!", {
                containerId: "A",
            })
        } else if (date === "") {
            toast.error("⛔ Email obligatoire !!", {
                containerId: "A",
            })
        } else if (selectNationality === "") {
            toast.error("⛔ Nationalité  obligatoire !!", {
                containerId: "A",
            })
        } else if (lieuNaissance === "") {
            toast.error("⛔ Lieu de Naissance obligatoire !!", {
                containerId: "A",
            })
        } else if (tel === "") {
            toast.error("⛔ Téléphone obligatoire !!", {
                containerId: "A",
            })
        } else if (rue === "") {
            toast.error("⛔ Rue obligatoire !!", {
                containerId: "A",
            })
        } else if (codePostal === "") {
            toast.error("⛔ Code postal  obligatoire !!", {
                containerId: "A",
            })
        } else if (selectGouvernorat === "") {
            toast.error("⛔ Gouvernorat obligatoire !!", {
                containerId: "A",
            })
        } else if (anneeBac === "") {
            toast.error("⛔ Année du bac obligatoire !!", {
                containerId: "A",
            })
        } else if (selectSection === "") {
            toast.error("⛔ Section  obligatoire !!", {
                containerId: "A",
            })
        } else if (selectMention === "") {
            toast.error("⛔ Mention  obligatoire !!", {
                containerId: "A",
            })
        } else if (selectSession === "") {
            toast.error("⛔ Session  obligatoire !!", {
                containerId: "A",
            })
        } else if (email !== "" && email != null) {
            const res = await API.post("etudiant/edit", {
                id: etudiant_id,
                nom_fr: nom,
                nom_ar: nomAr,
                prenom_fr: prenom,
                prenom_ar: prenomAr,
                cin: cin,
                sexe: sexe,
                dateNaissance: convertDate,
                lieuNaissance: lieuNaissance,
                nationalite: selectNationality.label,
                email: email,
                telephone: tel,
                etatCivil: etatCivil,
                rue: rue,
                codePostal: codePostal,
                fichier: pathFile,
                anneBac: anneeBac,
                derogataire: derogataire,
                type_inscription_id: selectTypeInscription.value,
                gouvernorat_id: selectGouvernorat.value,
                mention_id: selectMention.value,
                section_id: selectSection.value,
                session_id: selectSession.value,
                annee_id: annee_id,
                password: pass
            }).then(res => {
                if (res.data.errNum === 422 || res.data.errNum === "422") {
                    toast.error("⛔ " + res.data.msg, {containerId: "A"})
                } else if (res.data.status === 200 || res.data.status === "200") {
                    if (pathFile !== "") {
                        const formData = new FormData()
                        formData.append("document", file)
                        formData.append("annee", annee)
                        formData.append("entite", "etudiant")
                        formData.append("type", "photo")
                        formData.append("id", etudiant_id)
                        const resA = API.post("file/import", formData).then(resA => {
                        })
                    } else {
                        props.history.push("/dashboard")
                    }
                }

            })
        } else {
            toast.error("⛔  Remplir les champs obligatoires", {
                containerId: "A",
            })
        }
    }

    const passVerif = event => {
        var password = event
        const res = API.post("password_verification", {
            etudiant_id: etudiant_id,
            password: password,
            annee_id
        }).then(res => {
            var etat = res.data.Etudiant.etat
            if (etat == 0) {
                setErrPass(0)
            } else {
                setErrPass(1)
            }
        })
    }
    const handleValidSubmit = (event, values) => {
        // Ici tu peux appeler ta fonction de "modifier"
        console.log("Formulaire valide :", values.email);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Card>
                            <CardBody>
                                {loading ? (
                                    <Row>
                                        <AvForm onValidSubmit={handleValidSubmit}>
                                            <Form>
                                                <CardTitle style={{color: "#556ee6"}} className="h4 mb-4">
                                                    Informations générales :
                                                </CardTitle>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Nom : <span style={{
                                                                color: "red",
                                                                paddingLeft: "5px"
                                                            }}> *</span></Label>
                                                            <AvField
                                                                value={nom}
                                                                name="nom"
                                                                placeholder="Entrer nom"
                                                                type="text"
                                                                errorMessage="* nom obligatoire"
                                                                className="form-control"
                                                                validate={{required: {value: true}}}
                                                                onChange={e => setNom(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div dir="rtl" className="mb-3 rtl">
                                                            <Label dir="ltr" for="basicpill-firstname-input1">
                                                                : الإسم
                                                                <span
                                                                    style={{color: "red", paddingLeft: "5px"}}
                                                                >
                                  *
                                </span>
                                                            </Label>
                                                            <AvField
                                                                name="nomar"
                                                                placeholder="أدخل الاسم "
                                                                type="text"
                                                                errorMessage="*الاسم إجباري"
                                                                className="form-control rtl"
                                                                value={nomAr}
                                                                validate={{required: {value: true}}}
                                                                onChange={e => setNomAr(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>


                                                </Row>
                                                <Row>
                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Prénom : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <AvField
                                                                value={prenom}
                                                                name="prenom"
                                                                placeholder="Entrer prénom"
                                                                type="text"
                                                                errorMessage="* prenom obligatoire"
                                                                className="form-control"
                                                                validate={{required: {value: true}}}
                                                                onChange={e => setPrenom(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div dir="rtl" className="mb-3 rtl">
                                                            <Label dir="ltr" for="basicpill-firstname-input1">
                                                                : اللقب
                                                                <span
                                                                    style={{color: "red", paddingLeft: "5px"}}
                                                                >
                                  *
                                </span>
                                                            </Label>
                                                            <AvField
                                                                name="prenomar"
                                                                placeholder="أدخل اللقب "
                                                                type="text"
                                                                errorMessage="*اللقب إجباري"
                                                                className="form-control rtl"
                                                                value={prenomAr}
                                                                validate={{required: {value: true}}}
                                                                onChange={e => setPrenomAr(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>

                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">CIN : <span style={{
                                                                color: "red",
                                                                paddingLeft: "5px"
                                                            }}> *</span></Label>
                                                            <AvField
                                                                value={cin}
                                                                name="numero"
                                                                placeholder="Entrer numéro"
                                                                type="text"
                                                                errorMessage="Min 8 caractère"
                                                                className="form-control"
                                                                validate={{required: {value: true}, min: {value: 8}}}
                                                                onChange={e => setCin(e.target.value)}
                                                                disabled={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">
                                                                Date de Naissance :{" "} <span
                                                                style={{color: "red", paddingLeft: "5px"}}> *</span>
                                                            </Label>
                                                            <Col md={12} className="pr-0">
                                                                <DatePicker
                                                                    className="form-control ddate"
                                                                    selected={date}
                                                                    onChange={e => setDate(e)}
                                                                    dateFormat="dd/MM/yyyy"
                                                                />
                                                            </Col>
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <Row>
                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label className="d-block mb-3">Sexe : <span style={{
                                                                color: "red",
                                                                paddingLeft: "5px"
                                                            }}> *</span></Label>
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline1"
                                                                    name="customRadioInline1"
                                                                    className="form-check-input"
                                                                    checked={sexe == 1}
                                                                    onChange={e => setSexe(1)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline1"
                                                                >
                                                                    Masculin
                                                                </Label>
                                                            </div>
                                                            &nbsp;
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline2"
                                                                    name="customRadioInline1"
                                                                    className="form-check-input"
                                                                    checked={sexe == 2}
                                                                    onChange={e => setSexe(2)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline2"
                                                                >
                                                                    Féminin
                                                                </Label>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label className="d-block mb-3">Etat Civil : <span style={{
                                                                color: "red",
                                                                paddingLeft: "5px"
                                                            }}> *</span></Label>
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline5"
                                                                    name="customRadioInline5"
                                                                    className="form-check-input"
                                                                    checked={etatCivil === 1}
                                                                    onChange={e => setEtatCivil(1)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline5"
                                                                >
                                                                    Célibataire
                                                                </Label>
                                                            </div>
                                                            &nbsp;
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline6"
                                                                    name="customRadioInline5"
                                                                    className="form-check-input"
                                                                    checked={etatCivil === 2}
                                                                    onChange={e => setEtatCivil(2)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline6"
                                                                >
                                                                    Marié(e)
                                                                </Label>
                                                            </div>
                                                            &nbsp;
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline7"
                                                                    name="customRadioInline5"
                                                                    className="form-check-input"
                                                                    checked={etatCivil === 3}
                                                                    onChange={e => setEtatCivil(3)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline7"
                                                                >
                                                                    Divorcé(e)
                                                                </Label>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Nationalité
                                                                : <span
                                                                    style={{color: "red", paddingLeft: "5px"}}> *</span></Label>
                                                            <Select
                                                                value={selectNationality}
                                                                options={options}
                                                                isSearchable={true}
                                                                onChange={e => setSelectNationality(e)}
                                                            />
                                                        </div>
                                                    </Col> <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">
                                                            Lieu de Naissance : <span
                                                            style={{color: "red", paddingLeft: "5px"}}> *</span>
                                                        </Label>
                                                        <Input
                                                            value={lieuNaissance}
                                                            lg="3"
                                                            className="form-control"
                                                            placeholder="Entrer lieu de naissance"
                                                            type="text"
                                                            onChange={e => setLieuNaissance(e.target.value)}
                                                        />
                                                    </div>
                                                </Col>
                                                </Row>

                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Téléphone : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <AvField
                                                                value={tel}
                                                                name="tel"
                                                                placeholder="Entrer téléphone"
                                                                type="text"
                                                                className="form-control"
                                                                // validate={{  min: { value: 8 } }}
                                                                // validate={{ required: { value: true }, min: { value: 8 } }}
                                                                onChange={e => setTel(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Photo :</Label>
                                                            <Input
                                                                onChange={e => addFile(e)}
                                                                className="form-control"
                                                                type="file"
                                                                id="formFile"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <CardTitle style={{color: "#556ee6"}} className="h4 mb-4 mt-4">
                                                    Adresse :
                                                </CardTitle>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Rue : <span style={{
                                                                color: "red",
                                                                paddingLeft: "5px"
                                                            }}> *</span></Label>
                                                            <Input
                                                                value={rue}
                                                                lg="3"
                                                                className="form-control"
                                                                placeholder="Entrer rue"
                                                                type="text"
                                                                onChange={e => setRue(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Code postal
                                                                : <span
                                                                    style={{color: "red", paddingLeft: "5px"}}> *</span></Label>
                                                            <Input
                                                                value={codePostal}
                                                                lg="3"
                                                                className="form-control"
                                                                placeholder="Entrer code postal"
                                                                type="number"
                                                                onChange={e => setCodePostal(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Gouvernorat
                                                                : <span
                                                                    style={{color: "red", paddingLeft: "5px"}}> *</span></Label>
                                                            <Select
                                                                value={selectGouvernorat}
                                                                options={gouvernorat}
                                                                isSearchable={true}
                                                                onChange={e => setSelectGouvernorat(e)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <CardTitle style={{color: "#556ee6"}} className="h4 mb-4 mt-4">
                                                    Baccalauréat :
                                                </CardTitle>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">
                                                                Année du bac :{" "}<span
                                                                style={{color: "red", paddingLeft: "5px"}}> *</span>
                                                            </Label>
                                                            <Input
                                                                value={anneeBac}
                                                                lg="3"
                                                                className="form-control"
                                                                placeholder="Entrer année du bac"
                                                                type="text"
                                                                onChange={e => setAnneeBac(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Section : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <Select
                                                                value={selectSection}
                                                                options={section}
                                                                isSearchable={true}
                                                                onChange={e => setSelectSection(e)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>

                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Mention : <span
                                                                style={{color: "red", paddingLeft: "5px"}}> *</span>
                                                            </Label>
                                                            <Select
                                                                value={selectMention}
                                                                options={mention}
                                                                isSearchable={true}
                                                                onChange={e => setSelectMention(e)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Session : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <Select
                                                                value={selectSession}
                                                                options={session}
                                                                isSearchable={true}
                                                                onChange={e => setSelectSession(e)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                                <CardTitle style={{color: "#556ee6"}} className="h4 mb-4 mt-4">
                                                    Diplôme :
                                                </CardTitle>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Cycle : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <Select
                                                                options={cycle}
                                                                isSearchable={true}
                                                                value={selectCycle}
                                                                onChange={e => getNiveau(e)}
                                                                isDisabled={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Niveau :<span
                                                                style={{color: "red", paddingLeft: "5px"}}> *</span>
                                                            </Label>
                                                            <Select
                                                                options={niveau}
                                                                isSearchable={true}
                                                                value={selectNiveau}
                                                                isDisabled={true}
                                                                onChange={e => getSpec(e)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Spécialité :<span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <Select
                                                                options={specialite}
                                                                isSearchable={true}
                                                                value={selectSpecialite}
                                                                onChange={e => getGroupe(e)}
                                                                isDisabled={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label for="basicpill-firstname-input1">Groupe : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <Select
                                                                options={groupe}
                                                                isSearchable={true}
                                                                value={selectGroupe}
                                                                isMulti={true}
                                                                onChange={e => setSelectGroupe(e)}
                                                                isDisabled={true}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>

                                                    <Col md="6">
                                                        <div className="mb-3">
                                                            <Label className="d-block mb-3">Etat Etudiant : <span
                                                                style={{
                                                                    color: "red",
                                                                    paddingLeft: "5px"
                                                                }}> *</span></Label>
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline9"
                                                                    name="customRadioInline9"
                                                                    className="form-check-input"
                                                                    checked={derogataire === 1}
                                                                    onChange={e => setDerogataire(1)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline9"
                                                                >
                                                                    Dérogataire
                                                                </Label>
                                                            </div>
                                                            &nbsp;
                                                            <div className="form-check form-check-inline">
                                                                <Input
                                                                    type="radio"
                                                                    id="customRadioInline10"
                                                                    name="customRadioInline9"
                                                                    className="form-check-input"
                                                                    checked={derogataire === 2}
                                                                    onChange={e => setDerogataire(2)}
                                                                />
                                                                <Label
                                                                    className="form-check-label"
                                                                    htmlFor="customRadioInline10"
                                                                >
                                                                    Non Dérogataire
                                                                </Label>
                                                            </div>

                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label
                                                                for="basicpill-firstname-input1">{"Type d'inscription : "}
                                                                <span
                                                                    style={{color: "red", paddingLeft: "5px"}}> *</span></Label>
                                                            <Select
                                                                options={typeInscription}
                                                                isSearchable={true}
                                                                value={selectTypeInscription}
                                                                onChange={e => setSelectTypeInscription(e)}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <CardTitle
                                                    style={{color: "#556ee6"}}
                                                    className="h4 mb-4 mt-4"
                                                >
                                                    Mise a jour password :
                                                </CardTitle>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label>
                                                                E-mail
                                                                <span  style={{color: "red", paddingLeft: "5px"}} > *</span>
                                                            </Label>
                                                            <AvField
                                                                name="email"
                                                                placeholder="Entrer un email valide"
                                                                type="email"
                                                                value={email}
                                                                errorMessage="* Email obligatoire ou invalide"
                                                                className="form-control"
                                                                validate={{
                                                                    required: { value: true, errorMessage: "* Email obligatoire" },
                                                                    email: { value: true, errorMessage: "* Format d'email invalide" }
                                                                }}
                                                                onChange={e => setEmail(e.target.value)}
                                                            />

                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label>Password actuel</Label>
                                                            <Input
                                                                lg="3"
                                                                className="form-control"
                                                                type="password"
                                                                onBlur={e => passVerif(e.target.value)}
                                                            />
                                                            {errPass === 0 ? (
                                                                <small className="form-text text-danger">
                                                                    {"Password erroné"}
                                                                </small>
                                                            ) : null}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label>Nouveau password</Label>
                                                            <AvField
                                                                name="password"
                                                                type="password"
                                                                value={password}
                                                                onChange={e => setPassword(e.target.value)}
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col lg="6">
                                                        <div className="mb-3">
                                                            <Label>Verification password</Label>
                                                            <AvField
                                                                name="password1"
                                                                type="password"
                                                                value={verifPassword}
                                                                onChange={e => setVerifPassword(e.target.value)}
                                                                errorMessage="Verifier le password"
                                                                validate={{
                                                                    match: {value: "password"},
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>

                                            </Form>
                                            <div style={{display: "flex", justifyContent: "center"}}>
                                                <Col lg="12">
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}
                                                        className="text-center mt-4"
                                                    >
                                                        <button
                                                            onClick={editEtudiant}
                                                            type="submit"
                                                            className="btn btn-primary "
                                                        >
                                                            CONFIRMER
                                                        </button>
                                                    </div>
                                                </Col>
                                            </div>
                                        </AvForm>
                                    </Row>
                                ) : (
                                    <div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                            }}
                                        >
                                            {" "}
                                            <Spinner type="grow" className="ms-6" color="primary"/>
                                        </div>
                                        <h4
                                            style={{textAlign: "center", marginTop: "2%"}}
                                            className="ms-6"
                                        >
                                            {" "}
                                            {"Chargement"} ...{" "}
                                        </h4>
                                    </div>
                                )}
                            </CardBody>
                        </Card>
                    </Row>
                    <ToastContainer
                        transition={Slide}
                        enableMultiContainer
                        containerId={"A"}
                        position={toast.POSITION.TOP_RIGHT}
                        autoClose={2500}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Profile)

Profile.propTypes = {
    history: PropTypes.object,
}
